import axios from 'axios'
import {
  ACCOUNTS_API,
  WITH_CREDENTIALS_CONFIG,
  getAccountNotesApi,
} from './constants'

export const searchAccounts = (searchTerm: string) =>
  axios.get(
    `${ACCOUNTS_API}?q=${encodeURIComponent(searchTerm)}`,
    WITH_CREDENTIALS_CONFIG
  )

export const getExactAccount = (accountNumber: string) =>
  axios.get(
    `${ACCOUNTS_API}/${encodeURIComponent(accountNumber)}`,
    WITH_CREDENTIALS_CONFIG
  )

export const getAccountDetails = (accountNumber: string) =>
  axios.get(`${ACCOUNTS_API}/${accountNumber}`, WITH_CREDENTIALS_CONFIG)

export const getAccountNotes = (accountNumber: string) =>
  axios.get(getAccountNotesApi(accountNumber), WITH_CREDENTIALS_CONFIG)

export const getAccountOwners = (accountNumber: string) =>
  axios.get(`${ACCOUNTS_API}/${accountNumber}/owners`, WITH_CREDENTIALS_CONFIG)

export const getInterestedParties = (accountNumber: string) =>
  axios.get(
    `${ACCOUNTS_API}/${accountNumber}/interested_parties`,
    WITH_CREDENTIALS_CONFIG
  )

export const closeAccount = (account: string, replacementFdid?: string) =>
  axios.put(
    `${ACCOUNTS_API}/close`,
    {
      account,
      ...(replacementFdid && { replacementFdid }),
    },
    WITH_CREDENTIALS_CONFIG
  )
